export default __webpack_public_path__ + "static/media/Login.5ea6dedf.png";